<template>
  <div class="bank-document-preview">
    <div v-if="filePath && fileType === 'image'" class="doc-preview doc-preview--image">
      <img :src="filePath">
    </div>
    
    <!-- <iframe v-if="!showMobileViewer && filePath && fileType === 'pdf'" :src="filePath" class="doc-preview doc-preview--pdf" /> -->
    <!-- <GkPDFViewer v-if="showMobileViewer && filePath && fileType === 'pdf'" :item-pdf="filePath" /> -->


    <iframe v-if="!forceMobileViewer && !showMobileViewer && filePath && fileType === 'pdf'" id="pdf-frame" class="doc-preview doc-preview--pdf" :src="filePath"></iframe>
    <GkPDFViewer v-if="(forceMobileViewer || showMobileViewer) && filePath && fileType === 'pdf'" :item-pdf="filePath" />


    <div v-if="filePath && fileType === 'other'" class="doc-preview doc-preview--misc">
      <div class="misc-filetype-icon d-flex flex-column">
        <font-awesome-icon icon="fa-regular fa-file" />
        <div class="filename pt-2">
          {{ getLoadedFileName(filePath) }}
        </div>
      </div>
    </div>
    <div v-if="!filePath || !fileType" class="doc-preview doc-preview--misc">
      <div class="misc-filetype-icon file-not-uploaded d-flex flex-column">
        <font-awesome-icon icon="fa-solid fa-file-circle-question" />
        <div class="filename pt-2">
          {{ $gettext('No cost proof uploaded') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pdfviewer from "@/mixins/pdfviewer";

import GkPDFViewer from '@/components/invoices/ui/GkPDFViewer'

export default {
  name: "BankDocumentPreview",
  mixins: [pdfviewer],
  components: { GkPDFViewer },
  props: {
    filePath: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      fileType: null,
      loadingPDF: true
    }
  },
  created () {
    this.getFileType()
  },
  mounted () {
    this.loadingPDF = false;
  },
  methods: {
    getFileType () {
      if (this.filePath) this.fileType = window.getFileType(this.filePath)
    },
    getLoadedFileName (path) {
      if(!path){
        return;
      }
      const fileExtensionPattern = /[^/\\&?]+\.\w{3,4}(?=([?&].*$|$))/igm
      if(!path.match(fileExtensionPattern)){
        return this.$gettext('Unsupported file extension')
      }
      const file_extension_match = path.match(fileExtensionPattern)[0];
      return file_extension_match;
    },
  }
}
</script>

<style lang="scss" scoped>
.bank-document-preview {
  width: 100%;
  height: 100%;
  .gk-pdf-viewer {
    height: 100%;
    max-height: 500px;
  }
  .doc-preview {
    border-radius: $radiusSm;
    border: none;
    width: 100%;
    height: 100%;
    &--image {
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        object-fit: contain;
        width: 100%;
        height: 100%;
      }
    }
    &--pdf {
      width: 100%;
      height: 100%;
    }
    &--misc {
      display: flex;
      align-items: center;
      justify-content: center;
      .misc-filetype-icon {
        font-size: 60px;
        color: $colorBrand;
        &.file-not-uploaded {
          color: $colorUnassigned;
        }
        .filename {
          font-size: 16px;
          color: $colorTextBase;
        }
      }
    }
  }

}
</style>
